<template>
  <div class="order-row">
    <div class="flex-col bottom">
      <div class="flex-col">
        <span class="store_name">{{
          order.store && order.store.storeName
        }}</span>
        <span class="order_id">{{ order.order_id }}</span>
        <span class="order_id">Status: {{ order.status }}</span>
      </div>
      <div class="price-container">
        <span v-if="order.payment" class="sale-price">
          {{ order.payment.price | currency }}</span
        >
      </div>
      <span>{{
        `store.${order.store && order.store.storeName}` | translate
      }}</span>
      <template v-if="order.status == 'ReviseProducts'">
        <i class="material-icons cancel" @click="cancel(order)">
          cancel
        </i>
        <i class="material-icons check" @click="confirm(order)">
          check
        </i>
        <p v-if="processing">Processing...</p>
        <p v-if="confirmed">Error in updating order</p>
        <p v-if="canceled">Error in updating order</p>
        <p v-if="error">Error in updating order</p>
      </template>
    </div>
  </div>
</template>

<script>
import { confirmOrder, cancelOrder } from "../../services/api";
export default {
  name: "OrderView",
  props: { order: Object },
  data() {
    return {
      processing: false,
      confirmed: false,
      canceled: false,
      error: false
    };
  },
  methods: {
    handleResult(result, callback) {
      this.processing = false;
      if (result.status == 200) {
        callback();
      } else {
        // console.log(result);
        this.error = true;
      }
    },
    async confirm() {
      this.processing = true;
      const result = await confirmOrder(this.order);
      this.handleResult(result, () => (this.confirmed = true));
    },
    async cancel() {
      this.processing = true;
      const result = await cancelOrder(this.order);
      this.handleResult(result, () => (this.canceled = true));
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.order-row {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.image-container {
  position: relative;
  margin-bottom: 0.5rem;
  cursor: pointer;

  .material-icons {
    padding: 0.5rem;
    position: absolute;
    font-size: $font-base;

    @media (min-width: $breakpoint-md) {
      font-size: $font-m;
    }

    &.remove {
      left: 0;
      top: 0;
    }

    &.cart {
      bottom: 0;
      right: 0;
      border-radius: 50%;
      box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.25);
      margin: 0.375rem;
      background-color: $brand-white;
    }

    &.check {
      color: $brand-salmon;
      border-radius: 50%;
      box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.25);
      margin: 0.375rem;
    }
  }
}

.flex-col {
  flex: 1;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.size-select-container {
  display: none;

  &.visible {
    display: flex;
  }
}

.bottom {
  span {
    text-overflow: ellipsis;
    font-size: $font-xs;
    margin-bottom: 0.25rem;
  }

  .store_name {
    font-family: "Lora";
    font-size: $font-xs;
  }

  .order_id {
    font-size: $font-xs;
    font-family: "Montserrat-Bold";
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price-container {
    margin-top: -0.25rem;
    margin-bottom: 0.125rem;
  }

  .sale-price {
    font-weight: bold;
    color: $gyra-red;
    margin-right: 0.25rem;
  }
}
</style>
